import React from 'react'
import PropTypes from 'prop-types'

const RadioButtonOff = ({ color, width, height, ...props }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M8 15.166A6.667 6.667 0 118 1.832a6.667 6.667 0 010 13.334zm0-12a5.333 5.333 0 100 10.667A5.333 5.333 0 008 3.166z'
        fill={color}
      />
    </svg>
  )
}

RadioButtonOff.defaultProps = {
  color: 'currentColor',
  height: '24',
  width: '24',
}

RadioButtonOff.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default RadioButtonOff
